import React, {FC, ReactElement, SyntheticEvent} from 'react';
import {Box, ButtonBase, Link, makeStyles, Typography} from '@material-ui/core';
import DynamicIcon from '../icons/DynamicIcon';

const useStyles = makeStyles(theme => ({
    root: {
        transition: 'all .2s ease',
        left: 0,
        top: 0,
        height: '100%',
        width: '100%',
        '&:hover': {
            left: '-2%',
            top: '-2%',
            height: '104%',
            width: '104%'
        }
    },
    link: {
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.white,
        userSelect: 'none',
        textDecoration: 'none !important',
    },
    iconWrapper: {
        height: theme.typography.pxToRem(50),
        width: 'auto',
        marginBottom: theme.spacing(2.5),
    },
    icon: {
        height: theme.typography.pxToRem(50),
        width: 'auto',
    },
    label: {
        fontSize: theme.typography.pxToRem(18),
        textTransform: 'uppercase'
    }
}));

interface TileProps {
    label: string
    icon?: string
    url?: string
    cols?: number
    rows?: number
    color?: string
}

const Tile: FC<TileProps> = ({label, icon, url = '#', rows = 1, cols = 1, color = 'transparent'}): ReactElement => {
    const classes = useStyles();

    return (
        <ButtonBase
            className={classes.root}
            style={{gridColumn: `span ${cols}`, gridRow: `span ${rows}`, backgroundColor: color}}>
            <Link
                className={classes.link}
                href={url}
                {...(url === '#' && {onClick: (e: SyntheticEvent) => e.preventDefault()})}
                target="_blank">
                {!!icon && (
                    <Box className={classes.iconWrapper}>
                        <DynamicIcon name={icon} className={classes.icon}/>
                    </Box>
                )}
                <Typography
                    className={classes.label}
                    component="span">
                    {label}
                </Typography>
            </Link>
        </ButtonBase>
    );
};

export default Tile;
